import { render, staticRenderFns } from "./BSingleOptionSelection.vue?vue&type=template&id=5be4d699"
import script from "./BSingleOptionSelection.vue?vue&type=script&lang=js"
export * from "./BSingleOptionSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports